import React, { useEffect, useState } from "react";
import "../Asset/Css/ContacUs.css";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import axios from "axios";

const ContactUs = () => {
  const Base_Url = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    pincode: "",
    owner: "",
    partnership: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${Base_Url}sendMailContactUsLandingPg`,
        formData
      );
      console.log(response.data);
      if (response.data) {
        alert("We have recieved you form");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          city: "",
          pincode: "",
          owner: "",
          partnership: "",
          message: "",
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div>
      <Header></Header>
      <div class="contact-container">
        <div class="row">
          <div class="col-md-6 order-md-2 contact-form">
            <h1>Send us a message</h1>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 form-group mb-2">
                  <input
                    type="text"
                    name="name"
                    className="form-control form-control-sm"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group mb-2">
                  <input
                    type="email"
                    name="email"
                    className="form-control form-control-sm"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 form-group mb-2">
                  <input
                    type="text"
                    name="mobile"
                    className="form-control form-control-sm"
                    placeholder="Mobile Number"
                    value={formData.mobile}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setFormData((prevData) => ({ ...prevData, mobile: value }));
                    }}
                    required
                    maxLength={10}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group mb-2">
                  <input
                    type="text"
                    name="city"
                    className="form-control form-control-sm"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 form-group mb-2">
                  <input
                    type="text"
                    name="pincode"
                    className="form-control form-control-sm"
                    placeholder="Pincode"
                    value={formData.pincode}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setFormData((prevData) => ({ ...prevData, pincode: value }));
                    }}
                    required
                    maxLength={6}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 form-group mb-2">
                  <label className="mb-1" style={{ fontSize: "14px" }}>Are you a restaurant owner?</label>
                  <div className="d-flex gap-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="owner"
                        id="ownerYes"
                        value="yes"
                        checked={formData.owner === "yes"}
                        onChange={handleChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="ownerYes" style={{ fontSize: "14px" }}>Yes</label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="owner"
                        id="ownerNo"
                        value="no"
                        checked={formData.owner === "no"}
                        onChange={handleChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="ownerNo" style={{ fontSize: "14px" }}>No</label>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 form-group mb-2">
                  <label className="mb-1" style={{ fontSize: "14px" }}>Are you looking for partnership with My Food My Price?</label>
                  <div className="d-flex gap-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="partnership"
                        id="partnershipYes"
                        value="yes"
                        checked={formData.partnership === "yes"}
                        onChange={handleChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="partnershipYes" style={{ fontSize: "14px" }}>Yes</label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="partnership"
                        id="partnershipNo"
                        value="no"
                        checked={formData.partnership === "no"}
                        onChange={handleChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="partnershipNo" style={{ fontSize: "14px" }}>No</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group mb-2">
                <textarea
                  placeholder="Message"
                  className="form-control form-control-sm"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="2"
                  required
                ></textarea>
              </div>
              <div className="form-group d-flex justify-content-end mt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-sm btn-block btn-primary"
                >
                  {loading ? "Sending...." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
          <div class="col-md-6 order-md-1 contact-info">
            <h1>CONTACT US</h1>
            <p>We're open for any suggestion or just to have a chat</p>
            <ul>
              <li>
                <i className="fas fa-map-marker-alt"></i> 3rd Floor, Hamid Complex,
                No. 190 - 192, Opp. Ibis Hotel, Anna Salai, Thousand Lights,
                Chennai, Tamil Nadu - 600006
              </li>
              <li>
                <i className="fas fa-map-marker-alt"></i> Biryanipalayam,
                53/2 Sangu Nagar Main Road, Erode 638011
              </li>
              <li>
                <i class="fas fa-phone"></i> +91 9994210404
              </li>
              <li>
                <i class="fas fa-envelope"></i>
                <a href="mailto:info@biryanipalayam.com">
                  Info@myfoodmyprice.com
                </a>
              </li>
              <li>
                <i class="fas fa-envelope"></i>
                <a href="mailto:support@biryanipalayam.com">
                  Support@myfoodmyprice.com
                </a>
              </li>
              <li>
                <i class="fas fa-globe"></i>
                <a href="https://myfoodmyprice.com" target="_blank">
                  myfoodmyprice.com
                </a>
              </li>
              <li>
                <i className="fas fa-globe"></i>
                <a href="https://www.biryanipalayam.com/" target="_blank" rel="noopener noreferrer">
                  biryanipalayam.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default ContactUs;
